module.exports = __webpack_public_path__ + "static/img/10.bd06f63.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/10.png
// module id = M8LX
// module chunks = 4